export const phoneRegex = /^(\(\d{3}\)\s?|\d{3}[-\s]?)?\d{3}[-\s]?\d{4}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    return "Email is required.";
  }
  if (!emailRegex.test(value)) {
    return "Please enter a valid email address.";
  }
  return "";
};

// SIN validation:
function normalizeSIN(sin) {
  return sin?.replace(/\D/g, "");
}

function luhnCheck(sinDigits) {
  let sum = 0;
  let alternate = false;

  for (let i = sinDigits?.length - 1; i >= 0; i--) {
    let digit = parseInt(sinDigits[i], 10);
    if (alternate) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
    alternate = !alternate;
  }

  return sum % 10 === 0;
}

const knownInvalidSINs = new Set(["000000000", "111111111", "123456789"]);

export const isValidSIN = (sin) => {
  if (!sin) return false;
  const sinDigits = normalizeSIN(sin);
  if (sinDigits.length !== 9) return false;
  if (knownInvalidSINs.has(sinDigits)) return false;
  return luhnCheck(sinDigits);
};
